import React from 'react';
import useResponsiveFlags from '../../lib/useResponsiveFlags';
export const BreakpointContext = React.createContext(null);
export const BreakpointProvider = ({ children }) => {
    const responsiveFlags = useResponsiveFlags();
    return React.createElement(BreakpointContext.Provider, { value: responsiveFlags }, children);
};
